import * as angular from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {GroupModel} from "../groups/models/group.model";
import {ServiceAreaRequests} from "../service-areas/services/service-area-requests.service";
import {ViewSettingsService} from "../commons/services/view-settings-service.service";
import {ViewSettingsHolderType, ViewSettingsType} from "../commons/models/view-settings.model";
import {SettingsService} from "../site-preferences/services/settings-service.service";


angular
  .module('bringoz.admin.routes')
  .config(routesConfig);

function routesConfig($stateProvider) {

  $stateProvider

    .state('routes', {
      parent: 'bringoz.site',
      controllerAs: 'vm',
      url: '/routes?:from&:to&:serviceAreaIds&:routeStatuses&:agentIds&:routeIds&:resourceIds&:agentSkills&:branchIds&:groupIds',
      template: '<routes-view view-settings="vm.viewTableSettings" from="vm.from" to="vm.to" route-statuses="vm.routeStatuses" ids="vm.routeIds" service-area-ids="vm.serviceAreaIds" branch-ids="vm.branchIds" ' +
        'agent-ids="vm.agentIds" resource-ids="vm.resourceIds" agent-skills="vm.agentSkills" selected-quick-filter-id="vm.selectedQuickFilterId"' +
        'group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" date-range-template-type="vm.dateRangeTemplateType" service-areas-map="vm.serviceAreasMap">' +
        '</routes-view>',
      controller: function ($route, triBreadcrumbsService, commonsService: CommonsService, $stateParams, viewFilterSettingsService: ViewFilterSettingsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            groups, $state, serviceAreasMap, viewTableSettings, metadataSettings, site) {

        this.serviceAreasMap = serviceAreasMap;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        this.viewTableSettings = viewTableSettings?.reverse().find(v => v.holderType === ViewSettingsHolderType.User);

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds || [];
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.routeIds = commonsService.parseArrayStateParam($stateParams.routeIds);
        this.routeStatuses = commonsService.parseArrayStateParam($stateParams.routeStatuses) || quickActiveFilter?.settings?.routeStatuses;
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings?.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings?.agentIds;
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings?.agentSkills;
        this.resourceIds = commonsService.parseArrayStateParam($stateParams.resourceIds) || quickActiveFilter?.settings?.resourceIds;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Routes"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      },
      resolve: {
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        },
        serviceAreasMap: function (serviceAreaRequests: ServiceAreaRequests, site) {
          return serviceAreaRequests.getAreaNameMap();
        },
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        },
        viewTableSettings: function (viewSettingsService: ViewSettingsService, $state, site) {
          return viewSettingsService.getByUser('routes', ViewSettingsType.ViewTable);
        }
      }
    })

}
